export interface TypeMeta {
    code: string;
    id: string;
    nickname: string;
    subtitle: string;
    description: string;
    stats: {
        [key: string]: number;
    };
    bestMatches: {
        name: string;
        reason: string;
    }[];
    matchDescription: string;
    tips: string[];
    quote: string;
    themeAccent?: string;
}

export const TYPE_METADATA: Record<string, TypeMeta> = {
    '활동티미': {
        code: '활동티미',
        id: 'active',
        nickname: '활동티미',
        subtitle: '활동적이고 긍정적인',
        description: '활발하고 긍정적인 에너지로 팀 분위기를 이끄는 유형으로, 적극적으로 참여하며 분위기를 살리지만, 때로는 세부 계획보다는 즉흥적인 행동에 집중할 수 있습니다.',
        stats: {
            '긍정력': 5,
            '에너지': 5,
            '인사력': 4,
            '번개력': 4
        },
        bestMatches: [
            { name: '감각티미', reason: '즉흥적 아이디어와 순발력이 살아남' },
            { name: '긍정티미', reason: '활기와 분위기를 더함' }
        ],
        matchDescription: '감각티미와 함께할 때는 즉흥적 아이디어와 순발력이 살아나고, 긍정티미와는 활기와 분위기를 더하며, 셋이 모이면 팀 전체에 에너지와 창의적인 흐름이 형성됩니다.',
        tips: [
            '아이디어는 빠르게 시도해보자!\n활동 티미는 실행력이 강하니까, 아이디어가 나오면 시뮬레이션만 오래 하기보다는 작게라도 바로 실행해보는 태도가 팀에 활력을 줌.',
            '작은 성과를 눈에 보이게 하자.\n팀원들이 지치지 않도록, 진행 상황을 시각적으로 공유하거나 작은 성공을 체크하는 습관을 들이면 동기부여 효과가 큼.',
            '마감과 목표는 내가 확실히 챙긴다.\n실행력이 강한 캐릭터이니, 팀플의 데드라인을 확실하게 정리하고 체크리스트 담당자가 되면 신뢰도가 높아짐.'
        ],
        quote: '"빠른 실행으로 동력을 만들고, 모두가 함께 달릴 수 있도록 방향을 공유하자."',
        themeAccent: '#FE902F'
    },

    '감각티미': {
        code: '감각티미',
        id: 'sense',
        nickname: '감각티미',
        subtitle: '창의적이고 순발력 있는',
        description: '순간적인 상황 판단과 창의적인 아이디어로 팀 분위기를 살리는 유형으로, 빠른 순발력과 감각을 바탕으로 새로운 시도를 하지만, 체계적인 계획보다는 즉흥적인 선택이 많을 수 있습니다.',
        stats: {
            '순발력': 5,
            '창의력': 4,
            '즉흥력': 5,
            '분위기메이킹': 3
        },
        bestMatches: [
            { name: '활동티미', reason: '에너지와 행동력이 팀에 시너지' },
            { name: '실험티미', reason: '창의적 시도를 함께 빠르게 실행' }
        ],
        matchDescription: '감각티미와 활동티미가 함께하면 에너지와 행동력이 팀에 시너지를 만들고, 실험티미와 함께할 때는 창의적 시도를 빠르게 실행하며 팀워크가 완성됩니다.',
        tips: [
            '아이디어는 직관적으로 먼저 시도해보자!\n감각티미는 순간적인 판단과 창의력이 강하니, 아이디어가 떠오르면 완벽하게 계획하기보다 직관적으로 빠르게 시도해보는 것이 팀에 활력을 줌.',
            '팀 분위기를 읽고 상황에 맞게 움직이자.\n팀원들의 반응과 분위기를 살피며 즉흥적으로 아이디어를 조정하거나 제안하면, 자연스럽게 팀의 흐름을 이끌 수 있음.',
            '새로운 시도는 작은 성공으로 확인하자.\n즉흥적 선택이 많기 때문에, 작은 실험 등으로 결과를 확인하면 팀원들에게 신뢰와 동기부여를 줄 수 있음.'
        ],
        quote: '"순간의 아이디어를 믿고, 함께 움직이며 팀에 활력을 불어넣자!"',
        themeAccent: '#F13D32'
    },

    '통찰티미': {
        code: '통찰티미',
        id: 'insight',
        nickname: '통찰티미',
        subtitle: '깊이 보고 멀리 내다보는',
        description: '문제를 넓은 관점에서 직관적으로 파악하고 핵심을 빠르게 포착하는 유형으로, 직관과 통찰을 바탕으로 빠른 아이디어를 내지만, 세부 실행보다는 큰 그림에 집중하는 경향이 있습니다.',
        stats: {
            '통찰력': 5,
            '직관력': 4,
            '분석적사고': 3,
            '미래지향성': 4
        },
        bestMatches: [
            { name: '분석티미', reason: '직관과 데이터 기반 판단이 조화' },
            { name: '안정티미', reason: '차분함으로 큰 그림을 안정적으로 유지' }
        ],
        matchDescription: '통찰티미와 분석티미가 함께하면 직관과 논리적 판단이 조화를 이루고, 안정티미와 함께할 때는 차분함으로 팀의 큰 그림을 안정적으로 유지합니다.',
        tips: [
            '직관과 분석을 함께 활용하자.\n통찰티미는 직관력과 분석력이 조화로워, 데이터와 느낌을 함께 고려해 정확한 판단을 내림.',
            '팀의 큰 그림을 항상 염두에 두자.\n세부적인 실행보다 전체 방향성과 전략을 중심으로 팀을 이끌면 효율이 올라감.',
            '중요한 정보는 팀과 공유하자.\n통찰한 내용을 적절히 공유하면 팀원들의 판단력과 협업 능력이 함께 향상됨.'
        ],
        quote: '"한 발 앞선 직관과 분석으로 팀의 길을 밝히고, 모두가 함께 올바른 방향으로 나아갈 수 있도록 이끌자."',
        themeAccent: '#5761FF'
    },

    '융합티미': {
        code: '융합티미',
        id: 'fusion',
        nickname: '융합티미',
        subtitle: '다양한 생각을 엮어내는',
        description: '다양한 생각과 아이디어를 유기적으로 엮어내는 유형으로, 팀의 여러 의견을 조화롭게 연결하며 창의적인 해결책을 제시하지만, 아이디어가 많아 선택과 결정이 늦어질 수 있습니다.',
        stats: {
            '연결력': 5,
            '협업력': 4,
            '창의력': 4,
            '융통성': 3
        },
        bestMatches: [
            { name: '조율티미', reason: '다양한 의견을 조화롭게 연결' },
            { name: '창의티미', reason: '아이디어를 실질적 해결책으로 엮음' }
        ],
        matchDescription: '융합티미와 조율티미가 함께하면 다양한 의견을 조화롭게 연결하고, 창의티미와 함께할 때는 아이디어를 실질적 해결책으로 엮으며 팀워크가 완성됩니다.',
        tips: [
            '다양한 의견을 엮어보자.\n융합티미는 여러 시각과 정보를 연결하는 능력이 뛰어나니, 팀 아이디어를 하나로 모아 시너지를 만듦.',
            '협업에서 중심 역할을 맡자.\n팀원 간의 의견 차이를 조율하며 흐름을 유지하면 전체 성과가 안정적으로 올라감.',
            '아이디어를 실용적으로 바꾸자.\n창의적 발상이나 제안을 현실적 해결책으로 연결하면 팀에 실질적 도움이 됨.'
        ],
        quote: '"모든 생각과 아이디어를 하나로 엮어 팀의 목표를 실현하고, 함께 성장할 수 있는 흐름을 만들어가자."',
        themeAccent: '#F9DA4B'
    },

    '긍정티미': {
        code: '긍정티미',
        id: 'positive',
        nickname: '긍정티미',
        subtitle: '어려움 속에서도 팀의 사기를 지켜주는',
        description: '어려움 속에서도 팀의 사기를 지켜주고 분위기를 북돋우는 유형으로, 낙관적이고 따뜻한 태도로 팀을 안정시키지만, 때로는 현실적인 문제보다는 분위기 유지에 집중할 수 있습니다.',
        stats: {
            '긍정력': 5,
            '회복탄력성': 4,
            '격려력': 5,
            '낙관성': 4
        },
        bestMatches: [
            { name: '활동티미', reason: '함께 팀 분위기를 활기차게 만들 수 있음' },
            { name: '안정티미', reason: '차분함 속에서도 팀 사기를 지켜줌' }
        ],
        matchDescription: '긍정티미와 활동티미가 함께하면 팀 분위기를 활기차게 만들고, 안정티미와 함께할 때는 차분함 속에서도 팀 사기를 지켜주는 팀워크가 형성됩니다.',
        tips: [
            '팀 분위기를 먼저 챙기자.\n긍정티미는 에너지가 넘치니, 밝은 말과 행동으로 팀에 활기를 불어넣음.',
            '작은 성취도 크게 칭찬하자.\n진행 상황이나 작은 성공을 공유하면 팀원들의 동기부여와 자신감이 올라감.',
            '어려움 속에서도 희망을 보여주자.\n차분하지만 낙관적인 태도로 팀 사기를 유지하고, 신뢰를 높일 수 있음.'
        ],
        quote: '"언제나 밝고 긍정적인 에너지로 팀을 북돋우고, 함께 어려움을 극복하며 목표를 향해 나아가도록 하자."',
        themeAccent: '#9F4A11'
    },

    '실험티미': {
        code: '실험티미',
        id: 'experiment',
        nickname: '실험티미',
        subtitle: '도전적이고 과감한',
        description: '도전적이고 과감하게 새로운 시도를 하는 유형으로, 창의적인 아이디어를 빠르게 실행하며 팀에 신선한 변화를 주지만, 계획보다는 즉흥적인 선택에 의존할 수 있습니다.',
        stats: {
            '도전력': 5,
            '실행력': 4,
            '즉흥력': 5,
            '창의력': 4
        },
        bestMatches: [
            { name: '감각티미', reason: '즉흥적 시도와 창의적 실행력 시너지' },
            { name: '창의티미', reason: '새로운 아이디어를 실험하며 발전' }
        ],
        matchDescription: '실험티미와 감각티미가 함께하면 즉흥적 시도와 창의적 실행력이 시너지를 내고, 창의티미와 함께할 때는 새로운 아이디어를 실험하며 팀워크가 발전합니다.',
        tips: [
            '새로운 아이디어는 바로 시도해보자.\n실험티미는 실패를 두려워하지 않고, 작은 시도로도 빠르게 결과를 확인함.',
            '즉흥적 선택도 팀과 공유하자.\n팀원과 함께 조율하며 시행착오를 최대한 줄이고, 실행력을 높일 수 있음.',
            '결과는 기록하고 배움으로 활용하자.\n실험 데이터를 팀의 성장 자산으로 만들면 다음 시도에 더 큰 도움이 됨.'
        ],
        quote: '"실패를 두려워하지 않고 모든 시도를 경험하며, 배움을 쌓고 목표를 향해 나아갈 수 있는 흐름을 만들자."',
        themeAccent: '#1ADFDB'
    },

    '적응티미': {
        code: '적응티미',
        id: 'adaptive',
        nickname: '적응티미',
        subtitle: '어떤 환경에서도 제 역할을 해내는',
        description: '변화하는 상황에 유연하게 대응하고 팀의 흐름에 맞춰 조율합니다. 다양한 역할을 소화하며 안정적으로 문제를 해결하지만, 자신만의 주도적 결정보다는 주변 상황에 맞춰 움직이는 경향이 있습니다.',
        stats: {
            '유연성': 5,
            '수용력': 4,
            '협력력': 5,
            '상황대응력': 4
        },
        bestMatches: [
            { name: '안정티미', reason: '변화 속에서도 팀을 부드럽게 연결' },
            { name: '조율티미', reason: '다양한 의견 속에서 균형 유지' }
        ],
        matchDescription: '적응티미와 안정티미가 함께하면 변화 속에서도 팀을 부드럽게 연결하고, 조율티미와 함께할 때는 다양한 의견 속에서 균형을 유지하는 팀워크가 형성됩니다.',
        tips: [
            '변화에 유연하게 대응하자.\n적응티미는 상황 변화에 강하니, 팀이 흔들릴 때도 부드럽게 연결 역할을 수행함.',
            '팀원 의견을 적극 수용하자.\n다양한 시각을 이해하고 조화롭게 반영하면 팀 협력이 자연스럽게 높아짐.',
            '균형 있는 선택을 우선하자.\n팀 전체의 안정감과 흐름을 고려해 균형 있는 결정을 내리면 신뢰를 얻음.'
        ],
        quote: '"어떤 변화 속에서도 팀의 흐름을 부드럽게 이어가고, 모두가 함께 목표를 향해 나아갈 수 있게 만들자."',
        themeAccent: '#B97DEF'
    },

    '안정티미': {
        code: '안정티미',
        id: 'stable',
        nickname: '안정티미',
        subtitle: '차분하게 팀을 이끄는',
        description: '차분하게 팀을 이끌며 균형과 조화를 중요시하며, 상황을 침착하게 판단하고 팀의 흐름을 안정적으로 유지하지만, 변화나 즉각적 대응에서는 다소 느릴 수 있습니다.',
        stats: {
            '차분함': 5,
            '균형감': 5,
            '인내심': 4,
            '신뢰성': 4
        },
        bestMatches: [
            { name: '분석티미', reason: '차분함과 논리적 판단이 조화' },
            { name: '적응티미', reason: '유연성과 안정감이 시너지' }
        ],
        matchDescription: '안정티미와 분석티미가 함께하면 차분함과 논리적 판단이 조화를 이루고, 적응티미와 함께할 때는 유연성과 안정감이 시너지를 만드는 팀워크가 형성됩니다.',
        tips: [
            '차분함으로 팀을 이끌자.\n안정티미는 감정에 흔들리지 않고 침착하게 판단하니, 팀이 위기 상황에서도 중심을 잡을 수 있음.',
            '팀 내 균형을 항상 유지하자.\n극단적 선택보다 균형 있는 결정을 통해 팀 전체의 흐름과 효율을 높임.',
            '작은 실수에도 흔들리지 말자.\n팀원에게 신뢰를 주는 태도로 안정적인 분위기를 유지하면 협력이 강화됨.'
        ],
        quote: '"차분함으로 팀의 중심을 잡고, 어떤 상황에서도 흔들리지 않고 함께 목표를 향해 나아갈 수 있게 만들자."',
        themeAccent: '#62D264'
    },

    '분석티미': {
        code: '분석티미',
        id: 'analysis',
        nickname: '분석티미',
        subtitle: '근거로 설득하고 방향을 잡아주는',
        description: '문제를 논리적으로 분석하고 데이터 기반으로 해결하는 유형으로, 논리적이고 체계적인 판단으로 문제를 해결합니다. 논리적이고 체계적인 판단으로 문제를 해결하지만 가끔, 분석에 집중해 속도가 느려지기도 합니다.',
        stats: {
            '논리력': 5,
            '데이터력': 5,
            '계획력': 4,
            '집중력': 4
        },
        bestMatches: [
            { name: '통찰티미', reason: '직관과 논리적 판단이 보완됨' },
            { name: '완벽티미', reason: '체계적 계획과 정확성을 공유' }
        ],
        matchDescription: '분석티미와 통찰티미가 함께하면 직관과 논리적 판단이 조화를 이루고, 완벽티미와 함께할 때는 체계적 계획과 정확성을 공유하는 팀워크가 형성됩니다.',
        tips: [
            '논리적 판단을 최우선으로 하자.\n분석티미는 데이터와 근거 중심으로 생각하니, 팀 의사결정을 정확하게 도와줌.',
            '팀에 명확한 정보를 제공하자.\n정보를 체계적으로 정리하고 공유하면 팀원들이 판단을 빠르게 내릴 수 있음.',
            '계획과 실행을 연결하자.\n계획이 실행으로 이어지도록 체크리스트를 활용하면 팀 신뢰도와 효율이 올라감.'
        ],
        quote: '"논리와 근거를 바탕으로 팀을 똑똑하게 이끌고, 함께 올바른 방향으로 나아갈 수 있도록 만들자."',
        themeAccent: '#469AF0'
    },

    '창의티미': {
        code: '창의티미',
        id: 'creative',
        nickname: '창의티미',
        subtitle: '남들이 생각하지 못한 길을 제시하는',
        description: '남들이 생각하지 못한 새로운 길을 제시하는 유형으로, 독창적인 아이디어와 발상으로 팀에 신선한 시도를 가져오지만, 계획보다 아이디어 중심으로 움직이는 경향이 있습니다.',
        stats: {
            '창의력': 5,
            '독창성': 5,
            '상상력': 4,
            '실행력': 3
        },
        bestMatches: [
            { name: '실험티미', reason: '아이디어를 실제로 시도하며 시너지' },
            { name: '융합티미', reason: '다양한 의견과 아이디어를 연결' }
        ],
        matchDescription: '창의티미와 실험티미가 함께하면 아이디어를 실제로 시도하며 시너지를 내고, 융합티미와 함께할 때는 다양한 의견과 아이디어를 자연스럽게 연결하는 팀워크가 형성됩니다.',
        tips: [
            '독창적 아이디어를 자유롭게 내자.\n창의티미는 틀에 얽매이지 않고 상상력을 발휘해 새로운 해결책을 제시함.',
            '아이디어를 현실과 연결하자.\n팀원과 함께 실행 가능한 형태로 구체화하면 실제 성과로 이어질 수 있음.',
            '팀 의견을 다양하게 받아들이자.\n다른 시각을 조합하면 창의적 연결로 더 나은 해결책을 만들 수 있음.'
        ],
        quote: '"상상력을 마음껏 펼치고, 팀과 함께 아이디어를 실현하며 모두가 성장할 수 있는 흐름을 만들어가자."',
        themeAccent: '#6F66F3'
    },

    '조율티미': {
        code: '조율티미',
        id: 'coordination',
        nickname: '조율티미',
        subtitle: '다양한 의견을 맞춰 팀의 조화를 이끄는',
        description: '다양한 의견을 조화롭게 맞춰 팀의 균형을 이끄는 유형으로, 모두의 생각을 고려하며 협업을 원활하게 합니다. 하지만, 결정 과정에서 속도가 느려질 수 있습니다.',
        stats: {
            '협상력': 5,
            '조화력': 5,
            '의사소통력': 4,
            '균형감': 4
        },
        bestMatches: [
            { name: '융합티미', reason: '다양한 의견을 조화롭게 맞춤' },
            { name: '적응티미', reason: '팀 내 균형과 흐름 유지에 도움' }
        ],
        matchDescription: '조율티미와 융합티미가 함께하면 다양한 의견을 조화롭게 맞추고, 적응티미와 함께할 때는 팀 내 균형과 흐름을 자연스럽게 유지하는 팀워크가 형성됩니다.',
        tips: [
            '팀 의견을 조화롭게 연결하자.\n조율티미는 각자의 생각을 하나로 모아 팀 결정을 원활하게 하고, 의견 충돌을 줄임.',
            '갈등 상황에서는 중재하자.\n감정보다 균형과 합의를 우선하여 팀의 흐름을 안정적으로 유지하고자 노력함',
            '팀 목표와 흐름을 항상 공유하자.\n균형 있는 진행과 소통으로 팀의 전반적인 효율과 협업 수준을 높임.'
        ],
        quote: '"모든 의견을 조화롭게 엮어 팀이 하나로 나아가고, 함께 목표를 향해 안정적으로 움직일 수 있도록 만들자."',
        themeAccent: '#FBA8DC'
    },

    '완벽티미': {
        code: '완벽티미',
        id: 'perfect',
        nickname: '완벽티미',
        subtitle: '실수를 최소화해 완성도를 높이는',
        description: '모든 일을 꼼꼼하게 계획하고 철저하게 실행하는 유형으로, 높은 완성도와 품질을 중요시하며 실수 없이 일을 처리하지만, 세부까지 신경 쓰다 보니 속도가 느려질 수 있습니다.',
        stats: {
            '완성도': 5,
            '정밀함': 5,
            '체계력': 4,
            '집중력': 4
        },
        bestMatches: [
            { name: '분석티미', reason: '계획적 접근과 정확성이 조화' },
            { name: '안정티미', reason: '차분함과 완성도를 함께 보조' }
        ],
        matchDescription: '완벽티미와 분석티미가 함께하면 계획적 접근과 정확성이 조화를 이루고, 안정티미와 함께할 때는 차분함과 완성도를 함께 보조하는 팀워크가 형성됩니다.',
        tips: [
            '계획과 실행의 완성도를 높이자.\n완벽티미는 꼼꼼함과 체계력이 강하니, 작은 디테일까지 챙기며 팀 결과의 완성도를 높임.',
            '팀 기준과 절차를 명확히 하자.\n팀원들이 혼란스럽지 않도록 기준과 역할을 정리하고 공유하면 효율이 올라감.',
            '결과를 점검하고 개선하자.\n작은 실수도 놓치지 않고 기록해 수정하면 팀의 신뢰도와 완성도가 함께 높아짐.'
        ],
        quote: '"완벽함을 추구하며 팀의 결과를 최고로 만들자."',
        themeAccent: '#3B79FE'
    }
};
